import { VuexHelper } from '@amarkets/atlas/esm/lib/vuex-helper';
import state from './password/state';
import mutations from './password/mutations';
import getters from './password/getters';
import createActions from './password/actions';

export default function (context) {
  return VuexHelper.createStoreModule({
    states: [state],
    actions: [createActions(context)],
    mutations: [mutations],
    getters: [getters],
  });
}
